export const TreatmentCategories = ['skin', 'hair'] as const;

export const TreatmentCategoryMap = {
  skin: 'skin',
  hair: 'hair',
} as const;

export type TreatmentCategory = (typeof TreatmentCategories)[number];

export const TreatmentCategoryIds = {
  skin: 1,
  hair: 2,
} as const satisfies Record<TreatmentCategory, number>;

export type TreatmentCategoryId =
  (typeof TreatmentCategoryIds)[TreatmentCategory];
